'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var EventEmitter = require('events');

var Big = require('big.js');

var MovingAverage = require('moving-average');

var Stats =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Stats, _EventEmitter);

  function Stats(initialCounters, options) {
    var _this;

    _classCallCheck(this, Stats);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Stats).call(this));
    _this._options = options;
    _this._queue = [];
    _this._stats = {};
    _this._frequencyLastTime = Date.now();
    _this._frequencyAccumulators = {};
    _this._movingAverages = {};
    _this._update = _this._update.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    initialCounters.forEach(function (key) {
      _this._stats[key] = Big(0);
      _this._movingAverages[key] = {};

      _this._options.movingAverageIntervals.forEach(function (interval) {
        var ma = _this._movingAverages[key][interval] = MovingAverage(interval);
        ma.push(_this._frequencyLastTime, 0);
      });
    });
    _this._enabled = _this._options.enabled;
    return _this;
  }

  _createClass(Stats, [{
    key: "enable",
    value: function enable() {
      this._enabled = true;
    }
  }, {
    key: "disable",
    value: function disable() {
      this._disabled = true;
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
    }
  }, {
    key: "push",
    value: function push(counter, inc) {
      if (this._enabled) {
        this._queue.push([counter, inc, Date.now()]);

        this._resetComputeTimeout();
      }
    }
  }, {
    key: "_resetComputeTimeout",
    value: function _resetComputeTimeout() {
      if (this._timeout) {
        clearTimeout(this._timeout);
      }

      this._timeout = setTimeout(this._update, this._nextTimeout());
    }
  }, {
    key: "_nextTimeout",
    value: function _nextTimeout() {
      // calculate the need for an update, depending on the queue length
      var urgency = this._queue.length / this._options.computeThrottleMaxQueueSize;
      return Math.max(this._options.computeThrottleTimeout * (1 - urgency), 0);
    }
  }, {
    key: "_update",
    value: function _update() {
      this._timeout = null;

      if (this._queue.length) {
        var last;

        while (this._queue.length) {
          var op = last = this._queue.shift();

          this._applyOp(op);
        }

        this._updateFrequency(last[2]); // contains timestamp of last op


        this.emit('update', this._stats);
      }
    }
  }, {
    key: "_updateFrequency",
    value: function _updateFrequency(latestTime) {
      var _this2 = this;

      var timeDiff = latestTime - this._frequencyLastTime;
      Object.keys(this._stats).forEach(function (key) {
        _this2._updateFrequencyFor(key, timeDiff, latestTime);
      });
      this._frequencyLastTime = latestTime;
    }
  }, {
    key: "_updateFrequencyFor",
    value: function _updateFrequencyFor(key, timeDiffMS, latestTime) {
      var count = this._frequencyAccumulators[key] || 0;
      this._frequencyAccumulators[key] = 0;
      var hz = count / timeDiffMS * 1000;
      var movingAverages = this._movingAverages[key];

      if (!movingAverages) {
        movingAverages = this._movingAverages[key] = {};
      }

      this._options.movingAverageIntervals.forEach(function (movingAverageInterval) {
        var movingAverage = movingAverages[movingAverageInterval];

        if (!movingAverage) {
          movingAverage = movingAverages[movingAverageInterval] = MovingAverage(movingAverageInterval);
        }

        movingAverage.push(latestTime, hz);
      });
    }
  }, {
    key: "_applyOp",
    value: function _applyOp(op) {
      var key = op[0];
      var inc = op[1];

      if (typeof inc !== 'number') {
        throw new Error('invalid increment number:', inc);
      }

      var n;

      if (!this._stats.hasOwnProperty(key)) {
        n = this._stats[key] = Big(0);
      } else {
        n = this._stats[key];
      }

      this._stats[key] = n.plus(inc);

      if (!this._frequencyAccumulators[key]) {
        this._frequencyAccumulators[key] = 0;
      }

      this._frequencyAccumulators[key] += inc;
    }
  }, {
    key: "snapshot",
    get: function get() {
      return Object.assign({}, this._stats);
    }
  }, {
    key: "movingAverages",
    get: function get() {
      return Object.assign({}, this._movingAverages);
    }
  }]);

  return Stats;
}(EventEmitter);

module.exports = Stats;